export default class HomeSectionCtrl{
    
}


// WEBPACK FOOTER //
// ./src/app/modules/home/HomeSectionCtrl.js